export default __webpack_public_path__ + "static/media/slack_logo.ce1a96a8.svg";